import React from 'react'

const RightsholderRoyaltiesContentHeader = () => (
    <>
        <p>
            Select your desired distribution period from the drop-down menu to see a summary of information for that
            period.
        </p>
        <p>
            Notes on blanket licensing activities and dates for historical unmatched royalties, as well as the
            distribution certification, are available in PDF form at the bottom of the screen. PLEASE NOTE: This
            information is not unique to your account.
        </p>
    </>
)

export default RightsholderRoyaltiesContentHeader
